module.exports = __webpack_public_path__ + "r-v3/img/btn_send.d5256d02.svg";